import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Table from '../../components/Table';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
    getReportDetailsRequested,
    getReportsRequested,
    updateAttendance,
    updateGuestAttendance,
    updateTestimonies,
    updateEvaluations,
    updateDate,
    submitNewReportRequested
} from "../../actions/reportAction";
import { connect } from "react-redux";
import { ArrowLeftIcon, ClipboardListIcon, UserGroupIcon, AnnotationIcon } from '@heroicons/react/outline';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

/**
 * Renders a form for adding a new report, including fields for cell members, guests, testimonies, evaluations, and date.
 * @param {Object} props - The component props.
 * @param {Array} props.cellMembers - An array of cell members.
 * @param {Array} props.guests - An array of guests.
 * @param {Object} props.report - The report object.
 * @param {boolean} props.reportDetailsRequested - A boolean indicating whether report details have been requested.
 * @param {Function} props.updateAttendance - A function to update attendance.
 * @param {Function} props.updateGuestAttendance - A function to update guest attendance.
 * @param {Function} props.updateTestimonies - A function to update testimonies.
 * @param {Function} props.updateEvaluations - A function to update evaluations.
 * @param {Function} props.updateDate - A function to update the report date.
 * @param {Function} props.submitNewReportRequested - A function to submit a new report.
 * @param {Function} props.getReportDetailsRequested - A function to get report details.
 * @returns {JSX.Element} - The rendered component.
 */
const AddReport = ({
    cellMembers,
    guests,
    report,
    reportDetailsRequested,
    updateAttendance,
    updateGuestAttendance,
    updateTestimonies,
    updateEvaluations,
    updateDate,
    getReportsRequested: getReport,
    submitNewReportRequested: submitReport,
    getReportDetailsRequested: reportGetDetails,
}) => {
    // const [cellId, setCellId] = React.useState(null);
    // const location = useLocation(); 
    const navigate = useNavigate();
    const [errors, setErrors] = React.useState({});
    const [formIsValid, setFormIsValid] = React.useState(false);
    // const [loading, setLoading] = React.useState(false);
    // const [report, setReport] = React.useState(null);
    // const [testimonies, setTestimonies] = React.useState("");
    // const [evaluations, setEvaluations] = React.useState("");
    // const [cellMembers, setCellMembers] = React.useState([]);
    // const [guests, setGuests] = React.useState([]);
    // const [date, setDate] = React.useState("");
    // const dispatch = useDispatch();
    const { cellId } = useParams();

    React.useEffect(() => {
        const isValid = handleValidaton();
        setFormIsValid(isValid);
    }, [report]);

    React.useEffect(() => {
        if (!reportDetailsRequested) {
            reportGetDetails({ cellId });
        }
    }, [reportDetailsRequested]);

    const notify = (msg) => toast.success(msg, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
    });

    const handleClAttnOnchange = (id, value) => {
        updateAttendance({ id, value });
    }

    const allMembersSelected = cellMembers.length > 0 && cellMembers.every((member) => member.attendance === true);

    const handleToggleAllMembers = () => {
        const shouldSelectAll = !allMembersSelected;
        cellMembers.forEach((member) => {
            const memberId = member.id || member.member_id;
            if (memberId) {
                updateAttendance({ id: memberId, value: shouldSelectAll });
            }
        });
    };

    const handleClIrrOnchange = (id, value) => {
        if (cellMembers.length > 0) {
            cellMembers.map(member => {
                if (member.id === id) {
                    member.irregular = value;
                    return { ...member };
                }
                else {
                    return member;
                }
            })
            // setCellMembers([...cellMembers])
        }
    }

    /**
     * 
     * @param {guest_id} id 
     * @param {checkbox value} value 
     */
    const handleGsAttnOnchange = (id, value) => {
        updateGuestAttendance({ id, value });
    }

    const handleGsIrrOnchange = (id, value) => {
        if (guests.length > 0) {
            guests.map(member => {
                if (member.id === id) {
                    member.irregular = value;
                    return { ...member };
                }
                else {
                    return member;
                }

            })
            // setGuests([...guests])
        }
    }

    const handleTmChange = (e) => {
        updateTestimonies(e.target.value);
    }

    const handleEvChange = (e) => {
        updateEvaluations(e.target.value);
    }

    const handleDateChange = (e) => {
        updateDate(e.target.value);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Save report");
        // console.log(cellMembers);
        // console.log(guests);
        // console.log(report);
        // console.log(report.date);
        submitReport({
            cell_id: cellId,
            cellMemberAttendance: cellMembers,
            guestAttendance: guests,
            evaluations: report.evaluations,
            testimonies: report.testimonies,
            date: report.date,
        })
        notify("Report created successfully!");
        getReport(cellId);
        navigate('/dashboard/reports');
    }

    const handleValidaton = () => {
        let errors = {};
        let formIsValid = true;
        if (report != null && (report.date == null || report.date === "")) {
            formIsValid = false;
            errors["date"] = "Date cannot be empty";
        }

        setErrors(errors);
        return formIsValid;
    }

    const columns = React.useMemo(() => [
        {
            Header: "Name",
            accessor: 'name',
        },
        {
            Header: "Attended?",
            accessor: 'attendance',
            idAccessor: 'id',
            Cell: ({ value, column, row }) => (
                <div className="flex items-left">
                    <div className="ml-4">
                        {/* <input id={row.original.id} type="checkbox" value={value} checked={row.values.attendance || false} onChange={searchEvent} /> */}
                        <input id={row.original.id} type="checkbox" value={value} className="h-5 w-5 rounded border-2 border-gray-500 bg-white text-emerald-600 shadow-sm focus:ring-2 focus:ring-emerald-500 focus:ring-offset-1"
                            checked={row.values.attendance || false} onChange={e => { handleClAttnOnchange(row.original[column.idAccessor], e.target.checked) }} />
                    </div>
                </div>
            ),
        },
        // {
        //     Header: "Irregular?",
        //     accessor: 'irregular',
        //     idAccessor: 'id',
        //     Cell: ({ column, row, value }) => (
        //         <div className="flex items-left">
        //             <div className="ml-4">
        //                 <input id={row.original.id} type="checkbox" value={value} checked={row.values.irregular || false} onChange={e => { handleClIrrOnchange(row.original[column.idAccessor], e.target.checked) }} />
        //             </div>
        //         </div>
        //     ),
        // }
    ], [])

    const guestColumns = React.useMemo(() => [
        {
            Header: "Name",
            accessor: 'name',
        },
        {
            Header: "Attended?",
            accessor: 'attendance',
            idAccessor: 'id',
            Cell: ({ value, column, row }) => (
                <div className="flex items-left">
                    <div className="ml-4">
                        <input id={row.original.id} type="checkbox"
                            className="h-5 w-5 rounded border-2 border-gray-500 bg-white text-emerald-600 shadow-sm focus:ring-2 focus:ring-emerald-500 focus:ring-offset-1"
                            value={value} checked={row.values.attendance || false} onChange={e => { handleGsAttnOnchange(row.original[column.idAccessor], e.target.checked) }} />
                    </div>
                </div>
            ),
        },
        // {
        //     Header: "Irregular?",
        //     accessor: 'irregular',
        //     idAccessor: 'id',
        //     Cell: ({ column, row, value }) => (
        //         <div className="flex items-left">
        //             <div className="ml-4">
        //                 <input id={row.original.id} type="checkbox" value={value} checked={row.values.irregular || false} onChange={e => { handleGsIrrOnchange(row.original[column.idAccessor], e.target.checked) }} />
        //             </div>
        //         </div>
        //     ),
        // }
    ], [])



    // const data = React.useMemo(() => cellMembers, [])

    return (
        <div className="min-h-screen bg-gray-100 text-gray-900">
            <ToastContainer />
            {report && (
                <main className="max-w-full mx-auto px-4 sm:px-6 lg:px-8 py-6">
                    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-8">
                        <div className="flex items-center gap-3">
                            <button
                                onClick={() => navigate(-1)}
                                className="inline-flex items-center justify-center rounded-lg border border-gray-300 bg-white p-2 text-gray-700 shadow-sm hover:bg-gray-50"
                                type="button"
                            >
                                <ArrowLeftIcon className="h-5 w-5" />
                            </button>
                            <div>
                                <h1 className="text-3xl font-bold text-gray-900">Create Report</h1>
                                <p className="text-gray-500 mt-1">Record attendance, testimonies, and evaluations.</p>
                            </div>
                        </div>
                        <div className="bg-white shadow rounded-lg p-3 w-full sm:w-auto">
                            <label htmlFor="day" className="block text-sm font-medium text-gray-700">Report Date</label>
                            <input
                                className="mt-2 px-3 py-2 block w-full rounded-md border-0 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-emerald-600 sm:text-sm sm:leading-6"
                                autoComplete="Date"
                                required
                                name="date"
                                type="date"
                                value={report.date || ""}
                                onChange={handleDateChange}
                            />
                            {errors.date && <p className="mt-1 text-xs text-red-600">{errors.date}</p>}
                        </div>
                    </div>

                    <form className="space-y-6">
                        <section className="bg-white shadow-lg rounded-lg overflow-hidden">
                            <div className="px-6 py-5 border-b border-gray-200">
                                <div className="flex items-center justify-between gap-3">
                                    <div className="flex items-center gap-2">
                                        <UserGroupIcon className="h-5 w-5 text-emerald-600" />
                                        <h2 className="text-lg font-semibold text-gray-900">Section 1: Cell Members</h2>
                                    </div>
                                    {cellMembers.length > 0 && (
                                        <button
                                            type="button"
                                            onClick={handleToggleAllMembers}
                                            className="inline-flex items-center rounded-md border border-emerald-600 px-3 py-1.5 text-xs font-semibold text-emerald-700 hover:bg-emerald-50"
                                        >
                                            {allMembersSelected ? 'Clear all' : 'Select all members'}
                                        </button>
                                    )}
                                </div>
                                <p className="text-sm text-gray-500 mt-1">Indicate attendance details below.</p>
                            </div>
                            <div className="p-4">
                                {cellMembers && cellMembers.length > 0 ? (
                                    <Table columns={columns} data={cellMembers} />
                                ) : (
                                    <div className="py-8 px-4 text-center">
                                        <h3 className="text-lg font-semibold text-gray-700">No cell members found</h3>
                                    </div>
                                )}
                            </div>
                        </section>

                        <section className="bg-white shadow-lg rounded-lg p-6">
                            <div className="flex items-center gap-2">
                                <AnnotationIcon className="h-5 w-5 text-emerald-600" />
                                <h2 className="text-lg font-semibold text-gray-900">Section 2: Notes</h2>
                            </div>
                            <p className="text-sm text-gray-500 mt-1">Capture testimonies and evaluation notes for this meeting.</p>

                            <div className="mt-6">
                                <label htmlFor="testimonies" className="block text-sm font-medium text-gray-700">Testimonies</label>
                                <textarea
                                    id="testimonies"
                                    name="testimonies"
                                    rows={6}
                                    autoComplete="testimonies"
                                    required
                                    className="mt-2 px-3 py-2 block w-full rounded-md border-0 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-emerald-600 sm:text-sm sm:leading-6"
                                    value={report.testimonies || ""}
                                    onChange={handleTmChange}
                                />
                            </div>

                            <div className="mt-6">
                                <label htmlFor="evaluations" className="block text-sm font-medium text-gray-700">Evaluations</label>
                                <p className="text-sm text-gray-500 mt-1">(Comments and prayer requests)</p>
                                <textarea
                                    id="evaluations"
                                    name="evaluations"
                                    rows={6}
                                    autoComplete="evaluations"
                                    required
                                    className="mt-2 px-3 py-2 block w-full rounded-md border-0 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-emerald-600 sm:text-sm sm:leading-6"
                                    value={report.evaluations || ""}
                                    onChange={handleEvChange}
                                />
                            </div>
                        </section>

                        <section className="bg-white shadow-lg rounded-lg overflow-hidden">
                            <div className="px-6 py-5 border-b border-gray-200">
                                <div className="flex items-center gap-2">
                                    <ClipboardListIcon className="h-5 w-5 text-emerald-600" />
                                    <h2 className="text-lg font-semibold text-gray-900">Section 3: Guests</h2>
                                </div>
                                <p className="text-sm text-gray-500 mt-1">Indicate guest attendance details below.</p>
                            </div>
                            <div className="p-4">
                                {guests && guests.length > 0 ? (
                                    <Table columns={guestColumns} data={guests} />
                                ) : (
                                    <div className="py-8 px-4 text-center">
                                        <h3 className="text-lg font-semibold text-gray-700">No guests found</h3>
                                    </div>
                                )}
                            </div>
                        </section>

                        <div className="flex justify-end pb-2">
                            <SubmitButton disabled={!formIsValid} handleSubmit={handleSubmit} />
                        </div>
                    </form>
                </main>
            )}
        </div>
    );
};

const SubmitButton = ({ disabled, handleSubmit }) => {
    if (disabled) {
        return (
            <button
                disabled={true}
                className="bg-emerald-500 text-white font-semibold px-4 py-2 rounded-lg shadow-md opacity-40 cursor-not-allowed" type="button"
            >
                Save Report
            </button>
        )
    }
    return (
        <button
            disabled={false}
            onClick={handleSubmit}
            className="bg-emerald-500 text-white hover:bg-emerald-600 active:bg-emerald-700 font-semibold px-4 py-2 rounded-lg shadow-md transition-all duration-150" type="button"
        >
            Save Report
        </button>
    )
}
AddReport.propTypes = {
    report: PropTypes.object,
    cellMembers: PropTypes.array,
    guests: PropTypes.array,
    getReportDetailsRequested: PropTypes.func,
    getReportsRequested: PropTypes.func,
    reportDetailsRequested: PropTypes.bool,
}

AddReport.defaultProps = {
    report: null,
    cellMembers: [],
    guests: [],
    reportDetailsRequested: false,
}

const mapStateToProps = (state) => ({
    report: state.report.report,
    cellMembers: state.report.cellMembers,
    guests: state.report.guests,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    getReportDetailsRequested,
    getReportsRequested,
    submitNewReportRequested,
    updateAttendance,
    updateGuestAttendance,
    updateTestimonies,
    updateEvaluations,
    updateDate,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(AddReport);
